// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.step-width[data-v-4b0e9a24] {\n\twidth: 60px\n}\n.fixed[data-v-4b0e9a24] { \n\tposition: fixed !important; \n\ttop: 0; \n\tleft: 0;\n\twidth: 100%;\n\n\tz-index: 1000\n}\n.fixed-padding[data-v-4b0e9a24] {\n\tmargin-top: 220px\n}\n", ""]);
